import React, {
  useState,
  useRef,
  memo,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Select } from 'antd';
import './colorSelector.scss';

const { Option: SelectOption } = Select;

export const colorsMapping = {
  yellow: '#C28A00',
  green: '#27897E',
  purple: '#4B20AB',
  red: '#B5485B',
  blue: '#415385',
};
const colors = Object.values(colorsMapping);

function getKeyByValue(value) {
  return Object.keys(colorsMapping).find((key) => colorsMapping[key] === value);
}
const ColorBlock = ({ color }) => (
  <div className="color-block" style={{ backgroundColor: color }} />
);

const AgColorSelector = memo(
  forwardRef((props, ref) => {
    const [color, setColor] = useState(props.value);
    const refInput = useRef(null);

    const onColorChange = (newColor) => {
      setColor(newColor);
      props.afterChange &&
        props.afterChange(props.data.moduleId || props.data.id, {
          [props?.colDef?.field?.[0]]: newColor,
        });
      // onChange(newColor);
      // formChange();
    };

    useEffect(() => {
      refInput.current.focus();
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return color;
      },

      // // Gets called once before editing starts, to give editor a chance to
      // // cancel the editing before it even starts.
      // isCancelBeforeStart() {
      //   return false;
      // },

      // // Gets called once when editing is finished (eg if Enter is pressed).
      // // If you return true, then the result of the edit will be ignored.
      // isCancelAfterEnd() {
      //   // our editor will reject any value greater than 1000
      //   return value > 1000;
      // },
    }));

    return (
      <div className="color-selector">
        <Select
          ref={refInput}
          value={color}
          maxListHeight={270}
          onSelect={onColorChange}
          size="large"
          dropdownClassName="color-selector-dropdown"
        >
          {colors.map((e, i) => (
            <SelectOption value={getKeyByValue(e)} key={i}>
              <ColorBlock color={e} />
            </SelectOption>
          ))}
        </Select>
      </div>
    );
  }),
);

export default AgColorSelector;
